import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import { mergeStyles } from 'utils/cssString';

// import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	componentWillReceiveProps(nextProps, nextState) {
		super.componentWillReceiveProps?.(nextProps, nextState);
		if (nextProps.navOpen && !this.props.navOpen) {
			this.setState({ random: Math.random() });
		}
	}

	render(props, state) {
		const base = super.render(props, state);
		base.attributes.style = mergeStyles(base.attributes.style, { '--random': state.random || 0 });
		return base;
	}
}
